import React from 'react';
import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-soft-taupe py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 rounded-full bg-warm-sage flex items-center justify-center">
                <span className="text-cream-white font-serif text-xl">Э</span>
              </div>
              <span className="font-serif text-xl text-charcoal">Элина</span>
            </div>
            <p className="text-warm-gray text-sm leading-relaxed">
              Профессиональный психолог с высшим медицинским образованием. Более 1500 часов практики.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-lg text-charcoal mb-4">Навигация</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-warm-gray hover:text-warm-sage transition-colors text-sm">
                  Обо мне
                </a>
              </li>
              <li>
                <a href="#consultation" className="text-warm-gray hover:text-warm-sage transition-colors text-sm">
                  Консультации
                </a>
              </li>
              <li>
                <a href="#art-event" className="text-warm-gray hover:text-warm-sage transition-colors text-sm">
                  Груповая терапия
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-serif text-lg text-charcoal mb-4">Контакты</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="https://instagram.com/elina_tuleuova" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-warm-gray text-sm hover:text-warm-sage transition-colors"
                >
                  <Instagram size={18} className="text-warm-sage" />
                  <span>@elina_tuleuova</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-warm-gray/20 text-center">
          <p className="text-warm-gray text-sm">
            © 2025 Элина. Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
